import { render, staticRenderFns } from "./Cartera.vue?vue&type=template&id=1a12ad77&scoped=true"
import script from "./Cartera.vue?vue&type=script&lang=js"
export * from "./Cartera.vue?vue&type=script&lang=js"
import style0 from "./Cartera.vue?vue&type=style&index=0&id=1a12ad77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a12ad77",
  null
  
)

export default component.exports